import { ValueOf } from 'type-fest';

import { IIndexable } from '@/customtypes/common';
import { mainnet, polygon } from 'viem/chains';

export const SD = 'SD';
export const BNB = 'BNB';
export const ETH = 'ETH';
export const POLYGON = 'POLYGON';
export const FANTOM = 'FANTOM';
export const HEDERA = 'HEDERA';

interface CalculatorToken {
  [key: string]: string;
}

export const STADER_DAPPS = {
  SD: 'SD',
  ETH: 'ETH',
  POLYGON: 'POLYGON',
  BNB: 'BNB',
} as const;

export type StaderDapps = ValueOf<typeof STADER_DAPPS>;

export const SUPPORTED_CHAINS = [
  STADER_DAPPS.SD,
  STADER_DAPPS.ETH,
  STADER_DAPPS.BNB,
  STADER_DAPPS.POLYGON,
] as const;

export const REWARDSCALCULATORMAP: CalculatorToken = {
  SD,
  BNB,
  ETH,
  POLYGON: 'Matic',
  FANTOM: 'FTM',
  HEDERA: 'HBAR',
};

const getWithdrawalsDays = () => {
  const TOKEN = process.env.NEXT_PUBLIC_TOKEN;
  switch (TOKEN) {
    case ETH:
      return '7-10';
  }
  return '15';
};

export const STAKING_DISABLED_CHAINS = [FANTOM, BNB];

export const xTokenMapping: IIndexable = {
  ethx: 'ETHx',
  maticx: 'MaticX',
  bnbx: 'BNBx',
};

export const BINANCE_WALLET_IDS = ['binance', 'BinanceW3WSDK'];

export const STADER_URL = 'https://staderlabs.com/';
export const AUDIT_TOOLTIP_TEXT = 'Click to know more on audits';
export const TVL_TOOLTIP_TEXT = 'Total SD Staked';
export const TERMS_URL = 'https://staderlabs.com/terms-of-service/';
export const PRIVACY_POLICY_URL = 'https://staderlabs.com/privacy-policy/';
export const SUBSCRIPTIONS_URL = 'https://common.staderlabs.com/subscriptions';
export const TOAST_DURATION = 5000;
export const DAYS_TO_WAIT_FOR_WITHDRAW = getWithdrawalsDays();

export const getTransitionFee = (usdPrice: number, TOKEN: string) => {
  switch (TOKEN) {
    case HEDERA:
      return parseFloat((0.2 / usdPrice).toFixed(4));
    default:
      return null;
  }
};

export const TILL_DATE = '2024-05-31 16:00:00';

export const chainIconMapping = (chain: string) => {
  switch (chain) {
    case 'arbitrum':
      return '/assets/images/chains/arbitrum.svg';
    case 'optimism':
      return '/assets/images/chains/optimism.svg';
    case 'eth':
      return '/assets/images/chains/eth.svg';
    case 'xlayer':
      return '/assets/images/chains/xlayer-round.svg';
    case 'polygon':
      return '/assets/images/chains/polygon.svg';
    case 'gnosis':
      return '/assets/images/chains/gnosis.svg';
  }
  return '/assets/images/chains/optimism.svg';
};

export const chainIdIconMapping: Record<string, string> = {
  '1': '/assets/images/chains/ethereum.svg',
  '10': '/assets/images/chains/optimism.svg',
  '42161': '/assets/images/chains/arbitrum.svg',
  '196': '/assets/images/chains/xlayer.svg',
};

export type BridgeData = {
  route_details: {
    route_from: string;
    route_to: string;
    token_from: string;
    token_to: string;
  };
  cta: Array<{
    title: string;
    link: string;
  }>;
};

export const DAPP_PAGES = {
  STAKE: 'stake',
  BRIDGE: 'bridge',
  DEFI: 'defi',
  EMBED: 'embed',
  INDEX: 'index',
  NODE_OPERATORS: 'node-operators',
  UTILITY_POOL: 'utility_pool',
  VAULT: 'vault',
} as const;

export type DappPages = ValueOf<typeof DAPP_PAGES>;


export const STAKE_CONTRACTS_MAPPING = {
  [STADER_DAPPS.SD]: {
    address: '0xED6EE5049f643289ad52411E9aDeC698D04a9602',
  },
  [STADER_DAPPS.ETH]: {
    address: '0xcf5ea1b38380f6af39068375516daf40ed70d299',
  },
  [STADER_DAPPS.BNB]: {
    address: '0x3b961e83400D51e6E1AF5c450d3C7d7b80588d28',
  },
  [`${STADER_DAPPS.POLYGON}_${mainnet.id}`]: {
    address: '0xf03a7eb46d01d9ecaa104558c732cf82f6b6b645',
  },
  [`${STADER_DAPPS.POLYGON}_${polygon.id}`]: {
    address: '0xfd225C9e6601C9d38d8F98d8731BF59eFcF8C0E3',
  },
};


export const UNSTAKE_CONTRACTS_MAPPING = {
  [STADER_DAPPS.SD]: {
    address: '0xED6EE5049f643289ad52411E9aDeC698D04a9602',
  },
  [STADER_DAPPS.ETH]: {
    address: '0x9F0491B32DBce587c50c4C43AB303b06478193A7',
  },
  [STADER_DAPPS.BNB]: {
    address: '0x3b961e83400D51e6E1AF5c450d3C7d7b80588d28',
  },
  [`${STADER_DAPPS.POLYGON}_${mainnet.id}`]: {
    address: '0xf03a7eb46d01d9ecaa104558c732cf82f6b6b645',
  },
  [`${STADER_DAPPS.POLYGON}_${polygon.id}`]: {
    address: '0xfd225C9e6601C9d38d8F98d8731BF59eFcF8C0E3',
  },
};